import { motion } from "framer-motion";

// Scroll-triggered fade-up reveal wrapper.
export function Reveal({ children, delay = 0, y = 28, className = "", once = true }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
}

// Overline label — uppercase, wide tracking, accent tick.
export function Overline({ children, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-3 font-mono text-xs uppercase tracking-[0.28em] text-clan-accent ${className}`}>
      <span>{children}</span>
    </span>
  );
}
